import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './TotalSummary.scss';
import TotalSummarySearch from './TotalSummarySearch';
import TotalSummaryTable from './TotalSummaryTable';

const TotalSummary: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        document.title = "Total Summary";
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <TotalSummarySearch></TotalSummarySearch>
                <Grid container className="datatable">
                    <TotalSummaryTable>
                    </TotalSummaryTable>
                </Grid>
            </Grid>
        </>
    )
};

export default TotalSummary;